"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VeelgesteldeVragen() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const questions = ["Wat is een EPC-attest?", "Hoe lang duurt een EPC-keuring?", "Wat kost een EPC-keuring?", "Is een EPC-attest verplicht?", "Hoe lang is een EPC-attest geldig?", "Wat als mijn EPC-score laag is?"];
  return <section className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={leftRef} className={`flex flex-col justify-center transition-all duration-[250ms] ease-[var(--ease-smooth)] ${leftVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            <h2 className="mb-8 text-3xl font-bold text-foreground md:text-4xl">
              Veelgestelde vragen
            </h2>
            <ul className="space-y-4">
              {questions.map((question, i) => <li key={i} data-index={i} className={`flex items-start gap-3 transition-all duration-[250ms] ease-[var(--ease-smooth)] ${leftVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
              transitionDelay: leftVisible ? `${i * 60}ms` : "0ms"
            }}>
                  <Check className="mt-1 size-5 shrink-0 text-primary" />
                  <span className="text-base font-medium text-foreground md:text-lg">
                    {question}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div ref={rightRef} className={`flex items-center justify-center transition-all duration-[250ms] ease-[var(--ease-smooth)] ${rightVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/ekonorm_logo_large.png" alt="Ekonorm logo" className="h-auto w-full max-w-md object-contain" />
          </div>
        </div>
      </div>
    </section>;
}